import React = require('react');
import { UserNotificationsUserSettings } from '~src/userNotifications/components/settings/UserNotificationsUserSettings';
import { Messages } from '../../codegen/Localize';
import { IServerUserInfo } from '../../ts/models/IServerUserInfo';
import { ISiteUserInfo } from '../../ts/models/ISiteUserInfo';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import { UserSettingsHelper } from '../UserSettingsHelper';
import { DataAlertNotification } from './SuspendedDataAlertSetting';
import { SubscriptionNotification } from './SuspendedSubscriptionSetting';

export type NotificationsSettingsProps = {
  siteUser: ISiteUserInfo;
  serverUser: IServerUserInfo;
  userHasNoSiteId: boolean;
}

export function NotificationsSettings(props: NotificationsSettingsProps): JSX.Element {
  return (
    <>
      <h2 className={UserSettingsStyle.titleText}>{Messages.userNotificationSettingsLabel()}</h2>
      <table>
        <tbody>
          <tr>
            <td className={UserSettingsStyle.tbodyNew} colSpan={2}>
              <table>
                <tbody className={UserSettingsStyle.tbodyNew}>
                  <tr data-tb-test-id="userSettings-user-notifications-platform">
                    <UserNotificationsUserSettings />
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          {UserSettingsHelper.getSectionDividerLine()}
          <tr>
            <td className={UserSettingsStyle.tbodyNew} colSpan={2}>
              <SubscriptionNotification {...props} />
            </td>
          </tr>
          {UserSettingsHelper.getSectionDividerLine()}
          <tr>
            <td className={UserSettingsStyle.tbodyNew} colSpan={2}>
              <DataAlertNotification {...props} />
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
}